import React, { useRef } from "react";
import PropTypes from "prop-types";
import Icon from "components/atoms/Icon";
import ToolTip from "components/atoms/ToolTip";
import makeToggleable from "hoc/toggleable";
import classnames from "classnames";
import { APP_FILTER_TYPES, FACET_PATH_DELIMITER } from "constants/filter";

const ActiveFilter = ({
  name,
  className,
  label,
  tooltipIsActive,
  onResetFilter,
  onToggleTooltipIsActive,
  type,
  value,
}) => {
  const linkTextRef = useRef(null);

  const handleClick = () => {
    onResetFilter(name, value);
  };

  const isTooltipVisible = () => {
    const linkText = linkTextRef.current;
    return linkText && linkText.offsetWidth < linkText.scrollWidth;
  };

  const toggleTooltip = () => {
    if (tooltipIsActive) {
      onToggleTooltipIsActive(false);
    } else {
      onToggleTooltipIsActive(true);
    }
  };

  const componentBaseClass = "sal-active-filter";
  const componentClassName = classnames(componentBaseClass, className);
  const hasTooltip = isTooltipVisible();
  const filterLabel =
    type === APP_FILTER_TYPES.CASCADE
      ? value.split(FACET_PATH_DELIMITER).join(" / ")
      : label;

  let tooltipData = {};

  if (hasTooltip) {
    tooltipData.onMouseEnter = toggleTooltip;
    tooltipData.onMouseLeave = toggleTooltip;
  }

  return (
    <button
      className={componentClassName}
      onClick={handleClick}
      {...tooltipData}
      aria-label={`Filter "${filterLabel}" entfernen`}
    >
      <span className={`${componentBaseClass}__button`}>
        <span
          className={`${componentBaseClass}__button-text`}
          ref={linkTextRef}
        >
          {filterLabel}
        </span>
        <Icon
          type="Schliessen"
          className={`${componentBaseClass}__icon-remove`}
        />
      </span>
      {hasTooltip && (
        <ToolTip
          isActive={tooltipIsActive}
          className={`${componentBaseClass}__tooltip`}
        >
          {filterLabel}
        </ToolTip>
      )}
    </button>
  );
};

ActiveFilter.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onResetFilter: PropTypes.func.isRequired,
  onToggleTooltipIsActive: PropTypes.func,
  tooltipIsActive: PropTypes.bool,
  type: PropTypes.string,
  value: PropTypes.string.isRequired,
};

export default makeToggleable({ toggleProp: "tooltipIsActive" })(ActiveFilter);
